/*
 * @Author: Girish Akhare
 * @Date: 2022-01-20 18:08:06
 * @Last Modified by: Girish Akhare
 * @Last Modified time: 2022-12-16 18:14:07
 */

import { Component } from '@angular/core';

@Component({
  selector: 'not-found',
  templateUrl: 'not-found.component.html',
  styleUrls: ['not-found.component.scss']
})
export class NotFoundComponent {
  // count = 3;
  // // This param used to unscribe countDown function on destroy
  // isSubscribed = true;
  // ngOnInit() {
  //   this.isSubscribed = true;
  //   this.countDown();
  // }
  // countDown() {
  //   setTimeout(() => {
  //     --this.count;
  //     if (this.count < 1) {
  //       history.back();
  //     } else {
  //       if (this.isSubscribed) {
  //         this.countDown();
  //       }
  //     }
  //   }, 1000);
  // }
  // ngOnDestroy(): void {
  //   this.isSubscribed = false;
  // }
}
